import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledNewProductForm = styled.div`
  .ant-checkbox-group.create-product-delivery-check-box {
    width: 100%;
    .ant-table-wrapper {
      width: 100%;

      .ant-table-row:nth-child(n + 1) .ant-table-cell {
        padding: 24px 100px 24px 24px;
      }

      .ant-table-cell:nth-child(1) {
        text-align: left;
      }
      .ant-table-cell:nth-child(2) {
        text-align: right;
      }
    }
  }

  .empty-state {
    text-align: center;
    padding: 20px;
    color: ${(props) => props.theme.textSecondary};
  }

  .social-icons {
    margin-bottom: 16px;
  }

  .text-area {
    height: 90px;
  }

  .availability {
    .ant-form-item {
      margin-bottom: 30px;
    }
  }

  .ant-select-selector {
    border-radius: 3px !important;
  }

  .ant-input-number {
    border-radius: 3px !important;
  }

  .ant-input-number-affix-wrapper {
    border-radius: 3px !important;
  }

  .ant-picker {
    border-radius: 3px !important;
  }

  .ant-form-item-explain-error {
    font-size: 10px;
  }

  .desc {
    .ant-input {
      height: 152px;
    }
  }

  .ant-upload-list {
    display: flex;
    padding-top: 30px;
    gap: 20px;
  }
  .social-icons {
    display: flex;
    gap: 20px;

    img {
      cursor: pointer;
    }
  }
  .ant-input-affix-wrapper {
    border-radius: 5px;
  }

  .ant-input {
    border-radius: 5px;
  }

  .time {
    display: flex;
    flex-direction: column;
  }

  .ant-input-number-suffix {
    .unit-suffix {
      height: 100%;
      position: absolute;
      right: 0;
      display: flex;
      min-width: 57px;
      align-items: center;
      justify-content: center;
      border-left: 1px solid ${(props) => props.theme.inputAddonBg};
      background-color: ${(props) => props.theme.inputAddonBg};
    }

    .unit-suffix.mala {
      padding: 0 10px;
      font-size: 14px;
    }
  }

  .suffix {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
  }

  .image-upload {
    min-height: 98px;

    .ant-upload-drag,
    .ant-upload-btn,
    .ant-upload-drag-container {
      display: flex;
      flex-direction: column;
      width: 431px;
      height: 100px;
      align-items: center;
      justify-content: center;

      .ant-upload-drag-icon {
        margin: 0;
      }
    }

    .custom-upload-list {
      flex-direction: column;
      gap: 0;

      .custom-upload-list-item-container {
        position: initial;
      }
    }
  }

  .requirements {
    .reqs {
      display: flex;
      flex-direction: column;
      padding-top: 15px;
      padding-bottom: 15px;
      gap: 0;
      p {
        margin: 0;
      }
    }
  }

  .scnd-tr {
    min-width: 407px;
    min-height: 38px;
  }

  .flex {
    min-width: 261px;
    flex-grow: 1;
    min-height: 38px;
  }

  .amount-input {
    display: flex;
    flex-grow: 1;

    .ant-form-item-control-input-content {
      display: flex;
    }
  }

  .ant-flex .ant-row {
    flex-grow: 1;
  }

  .remove-button {
    height: 40px;
    width: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    color: ${(props) => props.theme.stepArrowColor};
    cursor: pointer;

    border-radius: 3px;
    border: 1px solid ${(props) => props.theme.borderInput};
    background-color: ${(props) => props.theme.inputAddonBg};
  }

  .col-djfgr {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    flex-grow: 1;
    gap: 30px;

    .min {
      .ant-form-item {
        margin: 0;
        .ant-input-number {
          width: 100%;
        }
      }
    }
    .price {
      white-space: nowrap;
      .ant-form-item {
        margin: 0;
        .ant-input-number {
          width: 100%;
        }
      }
    }
  }

  .products-structure-table {
    .ant-form-item {
      margin-bottom: 0;
    }
  }

  .checkboxes {
    margin-bottom: 20px;
  }

  .producer {
    .ant-form-item {
      margin-bottom: 8px;
    }

    .producer-row {
      display: flex;
      gap: 20px;

      > .ant-form-item {
        flex: 1;
        min-width: 0;
      }
    }

    .producer-feedback {
      font-size: 12px;
      margin-bottom: 16px;
      color: ${(props) => props.theme.stepArrowColor};

      &.error {
        color: ${(props) => props.theme.red};
      }
    }
  }

  .prod-availability {
    border-top: 1px solid ${(props) => props.theme.colorBorder};
    padding-top: 30px;
    border-bottom: 1px solid ${(props) => props.theme.colorBorder};
    padding-bottom: 30px;
  }

  .additional-info {
    padding-top: 30px;

    .readonly-marks {
      pointer-events: none;
    }

    .checkboxes {
      display: flex;
      flex-direction: row;
      gap: 400px;
      padding-top: 10px;

      .ant-checkbox-group {
        display: flex;
        gap: 10px;
        flex-direction: column;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .dynamic-range-row {
      flex-direction: column;
      gap: 0 !important;

      .amount-input {
        width: 100%;

        .ant-row {
          flex-direction: row;
        }
      }

      .remove-button-item {
        margin-bottom: 0;

        .ant-form-item-label {
          display: none;
        }

        .ant-form-item-control-input-content {
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }
`;
